import { render, staticRenderFns } from "./changeAccount-edit.vue?vue&type=template&id=d42bd352&scoped=true"
import script from "./changeAccount-edit.vue?vue&type=script&lang=js"
export * from "./changeAccount-edit.vue?vue&type=script&lang=js"
import style0 from "./changeAccount-edit.vue?vue&type=style&index=0&id=d42bd352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42bd352",
  null
  
)

export default component.exports